import React, { useEffect } from 'react';
import { ConfigProvider, Modal } from 'antd';
import PageNotFound from 'components/shared/Error';
import { IRoute } from 'interfaces/routesInt';
import AuthMiddleware from 'middlewares/authMiddleware';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import routes from 'routes';
import { usePlatformConfig } from 'hooks/PlatformContext';
import { CurrencyProvider } from 'hooks/userCurrency';
import enUS from 'antd/locale/en_US';
import frFR from 'antd/locale/fr_FR';
import { useLanguage } from 'hooks/Languages/useLanguage';

const locales: any = {
  en: enUS,
  fr: frFR,
};

function App() {
  const platformItem = usePlatformConfig();
  const { currentLanguage } = useLanguage();

  const currentLang: any = currentLanguage || 'en';

  useEffect(() => {
    const loginState = localStorage.getItem('newLogin');
    if (loginState === 'YES') {
      const timeout = setTimeout(() => {
        localStorage.setItem('newLogin', 'NO');
      }, 5000);
      return () => clearTimeout(timeout);
    }
  }, []);

  return (
    <ConfigProvider
      locale={locales[currentLang] || enUS}
      theme={{
        token: {
          colorPrimary: platformItem.primaryColor,
        },
      }}
    >
      <div className="App">
        <CurrencyProvider>
          <BrowserRouter basename="/">
            <Routes>
              {routes.map((route: IRoute, index: number) => {
                return route.isProtected ? (
                  <Route
                    key={index}
                    element={
                      <AuthMiddleware isAuthProtected={route.isProtected} />
                    }
                  >
                    <Route
                      path={route.path}
                      key={route.key}
                      index={route.index}
                      element={route.element}
                    />
                  </Route>
                ) : (
                  <Route
                    path={route.path}
                    key={route.key}
                    index={route.index || true}
                    element={route.element}
                  />
                );
              })}
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </BrowserRouter>
        </CurrencyProvider>
      </div>
    </ConfigProvider>
  );
}

export default App;
